import {Box, Button, ButtonGroup, styled, Table} from "@mui/material";

export const StickyContainer = styled(Box)`
  z-index: 2;
  position: sticky;
  top: 0;
  background-color: ${({theme}) => theme.palette.background.default};
`;
export const SubMenuGroup = styled(Box)`
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
  color: ${({theme}) => theme.palette.text.secondary};
  & div {
    color: ${({theme}) => theme.palette.text.secondary};
  }
`;
export const FilterGroup = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0px 6px;
  width: 100%;
  & .MuiInputBase-root {
    width: 180px;
    max-width: 200px;
  }
`;

export const StyledButtonGroup = styled(ButtonGroup)(
  ({theme}) => `
  display: flex;
  flex-shrink: 0;
  padding: 8px;
`
);

export const StyledButton = styled(Button)`
  font-size: 12px;
`;

// 테이블 리스트
export const StyledTable = styled(Table)(
  ({theme}) => `
   border-collapse: separate;
    th {
      border: ${theme.palette.mode === "light" ? "1px solid #d7d7da" : "1px solid #555555"}  ;
      
    }
    th, td {
      padding: 6px;
    }
    a:link  { 
      color: ${theme.palette.primary.main}

    }
    a:visited { 
      color: ${theme.palette.primary.main}

    }
    a:hover  { 
      color: ${theme.palette.primary.dark}

    }
`
);
